var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex"},[_c('BaseButton',{attrs:{"info":"","small":""},on:{"click":_vm.openModal}},[_vm._v(" Details ")]),_c('Portal',{attrs:{"to":"app-dialog"}},[(_vm.open)?_c('OrderItemDetailsModal',{attrs:{"order-item-id":_vm.orderItemId},on:{"close":_vm.closeModal}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }